import * as types from '../constants/ActionTypes';

const startRecording = () => ({ type: types.SPEECH_START_RECORDING });

const endRecording = () => ({ type: types.SPEECH_END_RECORDING });

const soundEndRecording = () => ({ type: types.SOUND_END_RECORDING });

const soundStartRecording = () => ({ type: types.SOUND_START_RECORDING });

const speechRecognitionRequest = query => ({
  type: types.SPEECH_RECOGNITION_REQUEST,
  payload: query,
});

const resetSpeechQuery = () => ({ type: types.RESET_SPEECH_QUERY });

module.exports = {
  startRecording,
  endRecording,
  speechRecognitionRequest,
  resetSpeechQuery,
  soundEndRecording,
  soundStartRecording,
};
